<template>
  <div ref="render"></div>
</template>

<script>
export default {
  props: {
    NO: {
      type: Number
    },
    // 饼图标题
    title: {
      type: String
    },
    // 文本颜色
    mainColor: {
      type: String,
      default: "#101E38"
    },
    // 提示文字
    textTip: {
      type: String,
      default: "客户数量"
    },
    // 颜色组关键词
    colorKey: {
      type: String
      // default:'green',
    },
    // 数据 数组
    data: {
      type: Array
    }
  },

  data() {
    return {};
  },

  computed: {
    // echart实例
    my_chart() {
      let dom = this.$refs.render;
      return dom && this.$echart.init(dom);
    },
    // 颜色数组
    color_arr() {
      switch (this.colorKey) {
        case "blue":
          return ["#6DB9FF", "#1890FF", "#0063BE", "#1C5285", "#002B53"];
        case "yellow":
          return ["#FFD76E", "#FFB900", "#D99D00", "#996F00", "#674B00"];
        case "orange":
          return ["#FFAA6E", "#FF6E09", "#933D00", "#D65800", "#FF8C00"];
        // green  或者其他乱七八糟的东西
        default:
          return ["#A4EA99", "#89D87D", "#6FC462", "#419934", "#205717"];
        // return ['#A4EA99','#89D87D','#6FC462','#419934','#205717'].reverse();
      }
    }
  },
  mounted() {
    setTimeout(() => {
      this.render();
    }, 300);
  },

  watch: {
    data:{
      handler(val, oldval) {
        this.render()
      },
      deep:true
    }
  },

  methods: {
    render() {
      let obj = {
        backgroundColor: "#fff",
        title: {
          text: this.title,
          x:'center',
          y:'bottom',
          textStyle: {
            color: this.mainColor,
            fontSize: 14,
            fontWeight:500,
          }
        },

        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },

        color: this.color_arr,

        visualMap: {
          show: false,
          min: 80,
          max: 600,
          inRange: {
            colorLightness: [0, 1]
          }
        },

        series: [
          {
            name: this.textTip,
            type: "pie",
            radius: "55%",
            center: ["50%", "50%"],
            data: this.data,
            // roseType: 'radius',   // 丁格尔玫瑰？？
            label: {
              normal: {
                textStyle: {
                  color: this.mainColor
                }
              }
            },

            labelLine: {
              normal: {
                lineStyle: {
                  color: "#a199ae"
                },
                smooth: 0.2,
                length: 5,
                length2: 15
              }
            },
            animationType: "scale",
            animationEasing: "elasticOut",
            animationDelay: function(idx) {
              return Math.random() * 200;
            }
          }
        ]
      };

      this.my_chart.setOption(obj);

      this.$emit("source", this.my_chart, this.NO);
    }
  }
};
</script>

<style>
</style>
